module.exports = __webpack_public_path__ + "img/header-bg.89b936bb.png";